import type { CalculationResult } from '~/pages/IncomeCalculator/types';

import { FORMULA1120 } from '../../../constants';
import { FormTypes } from '../../../enums';
import lang from '../language.json';
import BreakdownValue from '../styles/BreakdownValue';

type AnnualIncomeProps = {
  selectedResult: CalculationResult;
  currentYear: number;
  formulaId: number;
};

const AnnualIncome = ({
  selectedResult,
  currentYear,
  formulaId,
}: Readonly<AnnualIncomeProps>) => {
  const useAddbacks =
    formulaId === FORMULA1120.OneYearPositiveOrNegativeTend ||
    formulaId === FORMULA1120.TwoYearPositiveOrNegativeTrend;

  const annualIncome = selectedResult.getInputAsFloat(
    FormTypes.Form1120,
    currentYear,
    'annualIncome',
  );
  const medicareWages = selectedResult.getInputAsFloat(
    FormTypes.W2,
    currentYear,
    'medicareWages',
  );
  const borrowerShareOfIncome = selectedResult.getInputAsFloat(
    FormTypes.Form1120,
    currentYear,
    'borrowerShareOfIncomeOrLoss',
  );

  const {
    FIELDS: { ['1120']: FIELDS },
  } = lang;

  return (
    <BreakdownValue
      name={FIELDS.ANNUAL_INCOME}
      value={annualIncome}
      isCurrency={true}
    >
      <BreakdownValue name={FIELDS.ANNUAL_INCOME_WAGES} value={medicareWages} />
      {useAddbacks && (
        <BreakdownValue
          name={FIELDS.ANNUAL_INCOME_BORROWER_SHARES_INCOME}
          value={borrowerShareOfIncome}
        />
      )}
    </BreakdownValue>
  );
};

export default AnnualIncome;
